
class TD_PROCESS_CAROUSEL {
  constructor(el) {
    this.setBlockElements(el);
    
    this.currentIndex = 0;
    this.timer = null;
    this.autoplay = true;
    this.stopAutoplayOnClick = this.els.block.getAttribute('data-stop-on-click') === '1' ? true : false;
    this.speed = this.els.block.getAttribute('data-carousel-speed') ? parseInt(this.els.block.getAttribute('data-carousel-speed')) : 3000;

    this.startAutoplay();

    this.watchEvents();
  }

  setBlockElements(el) {
    this.els = {};
    this.els.block = el;
    this.els.images = this.els.block.querySelectorAll('.ps_carousel__image');
    this.els.content = this.els.block.querySelectorAll('.ps_carousel__content_item');
    this.els.nextBtn = this.els.block.querySelector('.ps_carousel__next');
    this.els.prevBtn = this.els.block.querySelector('.ps_carousel__prev');
  }
  
  startAutoplay() {
    if(this.autoplay){
      this.timer = setTimeout(() => {
        this.changeSlideIndex('next');
      }, this.speed);
    }
  }

  changeSlideIndex(direction = 'next') {
    if(this.timer){
      clearTimeout(this.timer);
    }
    
    if(direction == 'next'){
      this.currentIndex++;
      if(this.currentIndex >= this.els.images.length){
        this.currentIndex = 0;
      }
    }
    else {
      this.currentIndex--;
      if(this.currentIndex < 0){
        this.currentIndex = this.els.images.length - 1;
      }
    }
    
    this.updateCarousel();
    
    if(this.autoplay){
      this.startAutoplay();
    }
  }

  updateCarousel() {
    this.els.images.forEach((image, index) => {
      image.classList.remove('active');
      if(index === this.currentIndex){
        image.classList.add('active');
      }
    });

    this.els.content.forEach((content, index) => {
      content.classList.remove('active');
      content.setAttribute('aria-hidden', 'true');
      if(index === this.currentIndex){
        content.classList.add('active');
        content.setAttribute('aria-hidden', 'false');
      }
    });
  }
  watchEvents() {
    if(this.els.nextBtn){
      this.els.nextBtn.addEventListener('click', () => {
        if(this.stopAutoplayOnClick){
          this.autoplay = false;
          this.timer = null;
        }
        
        this.changeSlideIndex('next');
      });
    }

    if(this.els.prevBtn){
      this.els.prevBtn.addEventListener('click', () => {
        if(this.stopAutoplayOnClick){
          this.autoplay = false;
          this.timer = null;
        }

        this.changeSlideIndex('prev');
      });
    }
  }
}

// on document load
document.addEventListener('DOMContentLoaded', () => {
  const els = document.querySelectorAll('.ps_carousel');
  if(els.length){
    els.forEach(el => {
      el.carousel = new TD_PROCESS_CAROUSEL(el);
    });
  }
});
